// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypesPriority } from './TypesPriority';
import {
  TypesPriorityFromJSON,
  TypesPriorityFromJSONTyped,
  TypesPriorityToJSON,
  TypesPriorityToJSONTyped,
} from './TypesPriority';
import type { TypesCloudProvider } from './TypesCloudProvider';
import {
  TypesCloudProviderFromJSON,
  TypesCloudProviderFromJSONTyped,
  TypesCloudProviderToJSON,
  TypesCloudProviderToJSONTyped,
} from './TypesCloudProvider';
import type { TypesResourceStatus } from './TypesResourceStatus';
import {
  TypesResourceStatusFromJSON,
  TypesResourceStatusFromJSONTyped,
  TypesResourceStatusToJSON,
  TypesResourceStatusToJSONTyped,
} from './TypesResourceStatus';

/**
 *
 * @export
 * @interface TypesDatabaseMetadata
 */
export interface TypesDatabaseMetadata {
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  alias?: string;
  /**
   *
   * @type {TypesCloudProvider}
   * @memberof TypesDatabaseMetadata
   */
  cloudProvider?: TypesCloudProvider;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  createTime?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  dbId?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  dbSpec?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  destroyTime?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  dnsName?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  hostClusterId?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  isolationId?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  neo4jConfiguration?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  orchestra?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  owner?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  pluginDownload?: string;
  /**
   *
   * @type {TypesPriority}
   * @memberof TypesDatabaseMetadata
   */
  priority?: TypesPriority;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabaseMetadata
   */
  resumeTime?: string;
  /**
   *
   * @type {TypesResourceStatus}
   * @memberof TypesDatabaseMetadata
   */
  status?: TypesResourceStatus;
}

/**
 * Check if a given object implements the TypesDatabaseMetadata interface.
 */
export function instanceOfTypesDatabaseMetadata(
  value: object,
): value is TypesDatabaseMetadata {
  return true;
}

export function TypesDatabaseMetadataFromJSON(
  json: any,
): TypesDatabaseMetadata {
  return TypesDatabaseMetadataFromJSONTyped(json, false);
}

export function TypesDatabaseMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesDatabaseMetadata {
  if (json == null) {
    return json;
  }
  return {
    alias: json['Alias'] == null ? undefined : json['Alias'],
    cloudProvider:
      json['CloudProvider'] == null
        ? undefined
        : TypesCloudProviderFromJSON(json['CloudProvider']),
    createTime: json['CreateTime'] == null ? undefined : json['CreateTime'],
    dbId: json['DbId'] == null ? undefined : json['DbId'],
    dbSpec: json['DbSpec'] == null ? undefined : json['DbSpec'],
    destroyTime: json['DestroyTime'] == null ? undefined : json['DestroyTime'],
    dnsName: json['DnsName'] == null ? undefined : json['DnsName'],
    hostClusterId:
      json['HostClusterId'] == null ? undefined : json['HostClusterId'],
    isolationId: json['IsolationId'] == null ? undefined : json['IsolationId'],
    neo4jConfiguration:
      json['Neo4jConfiguration'] == null
        ? undefined
        : json['Neo4jConfiguration'],
    orchestra: json['Orchestra'] == null ? undefined : json['Orchestra'],
    owner: json['Owner'] == null ? undefined : json['Owner'],
    pluginDownload:
      json['PluginDownload'] == null ? undefined : json['PluginDownload'],
    priority:
      json['Priority'] == null
        ? undefined
        : TypesPriorityFromJSON(json['Priority']),
    region: json['Region'] == null ? undefined : json['Region'],
    resumeTime: json['ResumeTime'] == null ? undefined : json['ResumeTime'],
    status:
      json['Status'] == null
        ? undefined
        : TypesResourceStatusFromJSON(json['Status']),
  };
}

export function TypesDatabaseMetadataToJSON(json: any): TypesDatabaseMetadata {
  return TypesDatabaseMetadataToJSONTyped(json, false);
}

export function TypesDatabaseMetadataToJSONTyped(
  value?: TypesDatabaseMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Alias: value['alias'],
    CloudProvider: TypesCloudProviderToJSON(value['cloudProvider']),
    CreateTime: value['createTime'],
    DbId: value['dbId'],
    DbSpec: value['dbSpec'],
    DestroyTime: value['destroyTime'],
    DnsName: value['dnsName'],
    HostClusterId: value['hostClusterId'],
    IsolationId: value['isolationId'],
    Neo4jConfiguration: value['neo4jConfiguration'],
    Orchestra: value['orchestra'],
    Owner: value['owner'],
    PluginDownload: value['pluginDownload'],
    Priority: TypesPriorityToJSON(value['priority']),
    Region: value['region'],
    ResumeTime: value['resumeTime'],
    Status: TypesResourceStatusToJSON(value['status']),
  };
}
